import {str} from 'iblokz-data';

export const fieldToTitle = field => str.fromCamelCase(field, '-')
	.split('-').map(word => str.capitalize(word)).join(' ');

export const fieldLabel = (i18n, name) =>
	(i18n && i18n.fields && i18n.fields[name]) || fieldToTitle(name);

export const enumLabel = (i18n, group, value) =>
	(i18n && i18n.enums && i18n.enums[group] && i18n.enums[group][value]) || value;

export default {
	fieldToTitle,
	fieldLabel,
	enumLabel
};
